const EachRowDetails = ({ classesCSS, convertingDatatoArray }) => {
    const createEachDetail = (key, value, className) => {
        return <>{ value && <div className={className}>
             <div className={classesCSS.PersonalInfoLabelsPopup}>
                {key}
            </div>
            <p className={classesCSS.PersonalInfoValuesPopup}>{value}</p>
        </div>}</>
    }
    const createEachRow = () => {
        return <>{createEachDetail(convertingDatatoArray.key, convertingDatatoArray.value, classesCSS.gridRow)}</>
    }
    return <>{createEachRow()}</>
}

export default EachRowDetails;